module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "heading"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NOTE")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("The verses at the beginning of the first chapter are taken from the drama "), _c('em', [_vm._v("Nessuno")]), _vm._v(" (“No One”), by Luciano Nattino and Antonio Catalano, of the Alfieri Theater Company in Asti. The verses at the beginning of each of the other chapters are taken from songs by Stefano Maria Ricatti (from the CD "), _c('em', [_vm._v("Blu")]), _vm._v("—Rossodisera Records), a Venetian singer and songwriter, and a long-time friend of mine. I am especially fond of his recordings, which kept me company through countless sleepless nights. More generally, I would like to express my appreciation to the many artists who, over the years, gave me their support, friendship, and solidarity.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b5456c6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/fugitive_00001.vue
// module id = 69
// module chunks = 0